<div class="page-layout blank px-24">
  <p
    class="mat-error ml-15"
    *ngIf="
      courierPartnerForm?.get('courier')?.touched &&
      courierPartnerForm?.get('courier')?.invalid
    "
  >
    <error-message
      fieldName="Courier"
      [formControlErr]="courierPartnerForm?.get('courier')"
    ></error-message>
  </p>

  <div
    class="custom-card"
    ngClass.lt-sm="w-90-p"
    ngClass.lt-md="custom-card-width-md"
    *ngFor="let courier of courierPrices"
  >
    <mat-radio-group [formControl]="courierPartnerForm?.get('courier')">
      <div
        [ngClass]="
          courierPartnerForm?.get('courier')?.value === courier
            ? 'selected'
            : ''
        "
      >
        <div class="card-content" fxLayout="column">
          <div class="bottom-border text-center pt-12">
            <img
              class="logo-size mb-8"
              ngClass.lt-md="logo-size-md"
              src="assets/images/couriers/{{ courier.baseCourier }}.png"
              alt="logo"
            />
          </div>
          <div fxLayout="column" class="p-12">
            <mat-radio-button
              (change)="courierPartnerValue.emit(courier)"
              disableRipple="true"
              [value]="courier"
              fxLayout="row"
              fxLayoutAlign="start center"
              class="mt-12"
            >
              <p class="m-0">
                <span>Service:</span>
                <span
                  class="ml-12"
                  title="
              {{ courier.courierPartner }}
              "
                >
                  {{ courier?.price?.courierObj?.service }}
                </span>
                <span *ngIf="courier?.custom" class="custom_couriers">
                  Custom
                </span>
              </p>
            </mat-radio-button>

            <div fxLayout="column">
              <p fxLayout="row" fxLayoutAlign="start center" class="mb-0 mt-12">
                <span>Pricing Zone:</span>
                <span
                  *ngIf="courier?.price?.courierObj?.rateType === 'B2C'"
                  class="mx-12 cursor-pointer"
                  [ngClass]="{
                    'highlight-fg': courier?.price?.distanceChangeZone
                  }"
                  matTooltip="{{ courier?.price?.zone?.label }} - {{
                    courier?.price?.distanceChangeZone
                      ? deliveryZoneEDescription
                      : courier?.price?.zone?.description
                  }}"
                  matTooltipPosition="after"
                  >{{ courier?.price?.zoneName }}</span
                >
                <!-- <mat-icon
                  matTooltip="{{ courier?.price?.zone?.label }} - {{
                    courier?.price?.zone?.description
                  }}"
                  matTooltipPosition="after"
                  class="cursor-pointer"
                >
                  info_outline
                </mat-icon> -->
                <ng-container
                  *ngIf="courier?.price?.courierObj?.rateType === 'B2B'"
                >
                  <ng-container *ngFor="let zoneList of b2bCourierZones">
                    <span
                      class="mr-4 ml-12 cursor-pointer"
                      *ngIf="courier?.price?.pickupZone === zoneList?.key"
                      matTooltip="{{ zoneList?.zone }} - {{
                        zoneList?.description
                      }}"
                      matTooltipPosition="after"
                      >{{ zoneList?.zone }}
                    </span>
                  </ng-container>
                  <ng-container *ngFor="let zoneList1 of b2bCourierZones">
                    <span
                      class="mr-12 cursor-pointer"
                      *ngIf="courier?.price?.deliveryZone === zoneList1?.key"
                      matTooltip="{{ zoneList1?.zone }} - {{
                        zoneList1?.description
                      }}"
                      matTooltipPosition="after"
                      >to {{ zoneList1?.zone }}</span
                    >
                  </ng-container>
                  <ng-container *ngFor="let zone of zones">
                    <span
                      class="mr-4 ml-12 cursor-pointer"
                      *ngIf="courier?.price?.pickupZone === zone?.key"
                      matTooltip="{{ zone?.zone }} - {{ zone?.description }}"
                      matTooltipPosition="after"
                      >{{ zone?.zone }}
                    </span>
                    <span
                      class="mr-12 cursor-pointer"
                      *ngIf="courier?.price?.deliveryZone === zone?.key"
                      matTooltip="{{ zone?.zone }} - {{ zone?.description }}"
                      matTooltipPosition="after"
                      >to {{ zone?.zone }}</span
                    >
                  </ng-container>
                </ng-container>
              </p>
              <p fxLayout="row" fxLayoutAlign="start center" class="mb-0 mt-8">
                <span>Shipping Charge:</span>
                <ng-container
                  *ngIf="courier?.price?.courierObj?.rateType === 'B2C'"
                >
                  <span
                    fxShow
                    fxHide.lt-md
                    class="mx-12 cursor-pointer"
                    [matTooltip]="courier.price | breakupDetails"
                    matTooltipPosition="after"
                    >{{
                      courier?.price?.price
                        | RupeePaise: "rupee"
                        | currency: "INR"
                    }}
                  </span>
                  <span
                    fxHide.gt-sm
                    class="mx-12 cursor-pointer"
                    (click)="
                      shippingChargeInfo(courier, 'shipping charge details')
                    "
                    >{{
                      courier?.price?.price
                        | RupeePaise: "rupee"
                        | currency: "INR"
                    }}
                  </span>
                </ng-container>
                <ng-container
                  *ngIf="courier?.price?.courierObj?.rateType === 'B2B'"
                >
                  <span
                    class="mx-12 cursor-pointer accent-fg"
                    (click)="
                      shippingChargeInfo(courier, 'shipping charge details')
                    "
                    >{{
                      courier?.price?.price
                        | RupeePaise: "rupee"
                        | currency: "INR"
                    }}
                  </span>
                </ng-container>

                <!-- <mat-icon
                  fxShow
                  fxHide.lt-md
                  [matTooltip]="courier.price | breakupDetails"
                  color="mat-blue"
                  matTooltipPosition="after"
                  class="cursor-pointer"
                >
                  info_outline
                </mat-icon>

                <mat-icon
                  fxHide.gt-sm
                  color="mat-blue"
                  class="cursor-pointer"
                  (click)="
                    shippingChargeInfo(courier, 'shipping charge details')
                  "
                >
                  info_outline
                </mat-icon> -->
              </p>
              <p class="mb-0 mt-8" fxLayout="row" fxLayoutAlign="start center">
                <span>Charged Weight:</span>
                <span
                  fxShow
                  fxHide.lt-md
                  [matTooltip]="courier.price | weightDetails"
                  class="mx-12 cursor-pointer"
                  matTooltipPosition="after"
                  >{{
                    courier?.price?.deadWeight > courier?.price?.volWeight
                      ? (courier?.price?.deadWeight | weightConversionTo: "kg")
                      : (courier?.price?.volWeight | weightConversionTo: "kg")
                  }}
                  Kg
                </span>
                <span
                  fxHide.gt-sm
                  class="mx-12 cursor-pointer"
                  (click)="
                    shippingChargeInfo(courier, 'charged weight details')
                  "
                  >{{
                    courier?.price?.deadWeight > courier?.price?.volWeight
                      ? (courier?.price?.deadWeight | weightConversionTo: "kg")
                      : (courier?.price?.volWeight | weightConversionTo: "kg")
                  }}
                  Kg
                </span>

                <!-- <mat-icon
                  fxShow
                  fxHide.lt-md
                  [matTooltip]="courier.price | weightDetails"
                  color="mat-blue"
                  matTooltipPosition="after"
                  class="cursor-pointer"
                >
                  info_outline
                </mat-icon>

                <mat-icon
                  fxHide.gt-sm
                  color="mat-blue"
                  class="cursor-pointer"
                  (click)="
                    shippingChargeInfo(courier, 'charged weight details')
                  "
                >
                  info_outline
                </mat-icon> -->
              </p>

              <!-- TAT -->
              <p class="mb-0 mt-8" fxLayout="row" fxLayoutAlign="start center">
                <span fxLayout="row" fxLayoutAlign="start center"
                  >TAT
                  <mat-icon
                    [matTooltip]="tatDescription"
                    matTooltipPosition="after"
                    class="cursor-pointer"
                  >
                    info_outline </mat-icon
                  >:</span
                >
                <span class="mx-12">
                  {{ courier?.price?.tat | tat }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </mat-radio-group>
  </div>
</div>
